import { render, staticRenderFns } from "./usps.vue?vue&type=template&id=bae5058c&"
import script from "./usps.vue?vue&type=script&lang=js&"
export * from "./usps.vue?vue&type=script&lang=js&"
import style0 from "./usps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports